import React, { useState } from "react";
import {Multiselect} from "multiselect-react-dropdown";
import {Input} from "antd";
import './multiselect.component.css';
import { CloseCircleOutlined, FilterFilled,DownOutlined, UpOutlined, CaretDownOutlined, CaretUpOutlined  } from '@ant-design/icons';

export class MultiselectExtension extends Multiselect {
    constructor(props) {
        super(props);
        this.turnOnOptionList = this.turnOnOptionList.bind(this);
        this.turnOffOptionList = this.turnOffOptionList.bind(this);
        
        
        
    }
    turnOnOptionList() {
        this.setState({
            toggleOptionsList: true, 
            highlightOption: 0
        });
    }
    turnOffOptionList() {
       
       
       this.setState({
            toggleOptionsList: false, 
            highlightOption: 0
        });
    }
    
    
    
    renderMultiselectContainer() {
        const { inputValue, toggleOptionsList, selectedValues} = this.state;
        const { placeholder, style, singleSelect} = this.props;
        const isVisible = this.props || true;

       
        return (
            <div className={'multiSelectContainer'}
                 id="multiselectContainerReact"
                 style={style['multiselectContainer']}>
                <div className={`${'searchWarpper'} ${singleSelect ? 'singleSelect' : ''}`}
                     ref={this.searchWrapper} style={style['searchBox']}
                     onClick={singleSelect ? this.toggelOptionList : () => {}}
                >
                    <div className="chipInputWrapper"                              
 >
                       
                       <div className="chipContainer" > {this.renderSelectedList()}</div>
                        
                      
                        
                   
                         <Input
                            type="text"
                            bordered={false}
                            ref={this.searchBox}
                            // className="searchBox"
                            className={`searchBox ${singleSelect && selectedValues.length ? 'display-none' : ''}`}
                            
                            onChange={this.onChange}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}

                            onKeyPress={this.onKeyPress}

                            value={inputValue}

                            // placeholder={singleSelect && selectedValues.length ? '' : placeholder}
                            onKeyDown={this.onArrowKeyNavigation}
                            style={style['inputField']}
                            readOnly={true}
                            disabled={singleSelect}
                            suffix={toggleOptionsList ?
                                <CaretUpOutlined id="close-circle-icon"
                                    onClick={this.turnOffOptionList}
                                    
                                    style={{ margin: '0 10', padding: 0, color: 'rgba(0,0,0,.65)', display:'none' }} />
                                
                                    :
                                <CaretDownOutlined id="filter" onClick={this.turnOnOptionList}
                                    style={{ margin: '0 10', padding: 0, fontSize: '25px', color: selectedValues.length > 0 ? '#0096fb' : 'rgba(0,0,0,.65)' }} />
                            }
                            
                        
                            />

                        
                        </div>
                    {singleSelect && <i
                        className={`icon_cancel ${'icon_down_dir'}`}
                    />}
                </div>
                
                {(selectedValues.length > 1 && isVisible == true) &&<button type='button' className='btn btn-primary btn-block'
                style={{ marginBottom: '14px', width: '100px' }} onClick={this.props.resetSelectField}>Clear All</button>}
                <div
                    className={`optionListContainer ${'optionListContainer'}
                     
                    ${toggleOptionsList ? 'displayBlock' : 'displayNone'}`
                    }
                    onMouseDown={(e) => {
                        e.preventDefault();
                      }}
                >
                    {this.renderOptionList()}
                </div>
            </div>

        );
    }
}

export default MultiselectExtension;
